// TODO: Cleanup usings. use aliases

import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@common/ui/material';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import {
  D3CalloutBoxComponent,
  D3LegacyAlertDialogComponent,
  D3LegacyConfirmDialogComponent,
  D3ModalDialogComponent,
  D3FieldsetControlComponent,
  D3FormControlComponent,
  D3FeedbackDialogComponent,
  D3DateTimeRangePickerComponent,
  D3DetailsComponent,
} from './d3-shared-components.components';
import { UiSharedComponentsModule } from '@common/ui/shared-components';
// import { DragDropWorkerComponent } from './document-upload/drag-drop-worker/drag-drop-worker.component';
import {
  GoabButton,
  GoabButtonGroup,
  GoabMicrositeHeader,
  GoabAppHeader,
  GoabCallout,
  GoabNotification,
  GoabModal,
  GoabIcon,
  GoabIconButton,
  GoabAccordion,
  GoabBadge,
  GoabContainer,
  GoabGrid,
  GoabTable,
  GoabTabs,
  GoabTab,
  GoabFormItem,
  GoabDetails,
  GoabFileUploadInput,
  GoabDivider,
  GoabSpacer,
  GoabInput,
  GoabTextArea,
  GoabRadioItem,
  GoabRadioGroup,
  GoabInputNumber,
  GoabDropdown,
  GoabDropdownItem,
  GoabBlock,
  GoabDatePicker,
  GoabCheckbox,
} from '@abgov/angular-components';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    UiSharedComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    GoabButton,
    GoabButtonGroup,
    GoabMicrositeHeader,
    GoabAppHeader,
    GoabCallout,
    GoabNotification,
    GoabModal,
    GoabIcon,
    GoabIconButton,
    GoabAccordion,
    GoabBadge,
    GoabContainer,
    GoabGrid,
    GoabTable,
    GoabTabs,
    GoabTab,
    GoabFormItem,
    GoabDetails,
    GoabFileUploadInput,
    GoabDivider,
    GoabSpacer,
    GoabInput,
    GoabTextArea,
    GoabRadioItem,
    GoabRadioGroup,
    GoabInputNumber,
    GoabBlock,
    GoabDatePicker,
    GoabDropdown,
    GoabDropdownItem,
    GoabCheckbox,
  ],
  declarations: [
    D3CalloutBoxComponent,
    D3LegacyAlertDialogComponent,
    D3LegacyConfirmDialogComponent,
    D3ModalDialogComponent,
    D3FieldsetControlComponent,
    D3FormControlComponent,
    D3FeedbackDialogComponent,
    D3DateTimeRangePickerComponent,
    D3DetailsComponent,
  ],
  exports: [
    D3CalloutBoxComponent,
    D3LegacyAlertDialogComponent,
    D3LegacyConfirmDialogComponent,
    D3ModalDialogComponent,
    D3FieldsetControlComponent,
    D3FormControlComponent,
    D3FeedbackDialogComponent,
    D3DateTimeRangePickerComponent,
    D3DetailsComponent,
  ],
})
export class D3SharedComponentsModule {}
